import { useEffect, useState } from "react";
import { producaov2 } from "../../../services/apis";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { Table } from "semantic-ui-react";
import { ActionButtons, ButtonPagination, Container, PaginationContainer } from "./styles";
import { FaRegEdit } from "react-icons/fa";
import InputSearch from "../../Admin/NovoEmpresas/components/InputSearch";

export const MBAListComplete = () => {
  const [mbas, setMbas] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getMbas(page, search);
  }, [search, page]);

  const getMbas = (page, search) => {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (search) queryParams.append("buscaEmail", search);

    producaov2
      .get(`/admin/mba/list-complete?${queryParams}`)
      .then((response) => {
        const { data } = response;

        setMbas(data.mbas);
        setTotalPages(data.totalPages);
      });
  };

  return (
    <>
      <AdminMenu />
      <Container>
        <h1>Lista MBAs</h1>

        <div>
            <InputSearch
              placeholder='Pesquisar'
              value={search}
              onChange={e => {setPage(1); setSearch(e.target.value)}}
              noIcon
              minWidth='500px'
            />
          </div>

          <PaginationContainer>
            <div>
              {Array.from(Array(totalPages).keys()).map((_, index) => (
                <ButtonPagination
                  active={page === index + 1}
                  onClick={() => setPage(index + 1)}
                >
                  {index + 1}
                </ButtonPagination>
              )).slice(
                page <= 2 ? 0 : page + 2 >= totalPages ? totalPages - 5 : page - 3, // clean code :)
                page <= 2 ? 5 : page + 2 >= totalPages ? totalPages : page + 2
              )}
            </div>
          </PaginationContainer>

        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>ID Curso</Table.HeaderCell>
            <Table.HeaderCell>ID Combo</Table.HeaderCell>
            <Table.HeaderCell>Descrição</Table.HeaderCell>
            <Table.HeaderCell>Pessoa</Table.HeaderCell>
            {/* <Table.HeaderCell>Ativo</Table.HeaderCell> */}
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Header>

          <Table.Body>
            {mbas &&
              mbas.map((mba) => (
                <Table.Row key={mba.id}>
                  <Table.Cell>{mba.id}</Table.Cell>
                  <Table.Cell>{mba.id_curso}</Table.Cell>
                  <Table.Cell>{mba.id_combo}</Table.Cell>
                  <Table.Cell>{mba.descricao}</Table.Cell>
                  <Table.Cell>{mba?.pessoa?.email || ""}</Table.Cell>
                  {/* <Table.Cell>{mba.is_active ? "S" : "N"}</Table.Cell> */}
                  <Table.Cell>
                    <ActionButtons>
                      <a href={`/admin/mba/list/${mba.id}`}>
                        <FaRegEdit size={16} color="var(--color-primary)" />
                      </a>
                    </ActionButtons>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Container>
    </>
  );
};
